import React from 'react';
import { Headline, Text } from '@oneaudi/unified-web-components';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import { TextSlideProps } from './ComponentTypes';
import { StyledCopy, StyledFooter, StyledHeadline, StyledTextSlide } from './Styles';
import { useI18n } from '../i18n';

// eslint-disable-next-line react/no-unused-prop-types
// eslint-disable-next-line @typescript-eslint/no-shadow
const WltpText: React.FC<{ testId: string; children?: React.ReactNode }> = ({
  children,
  testId,
}) => {
  return (
    <Text
      data-testid={testId}
      variant={{ order: process.env.IS_LEGACY ? '2' : '3', style: 'normal' }}
    >
      {children}
    </Text>
  );
};

const TextSlide = React.forwardRef<HTMLDivElement, TextSlideProps>(
  ({ content, active, testId, ...ueProps }, ref) => {
    const { wltpData } = content;
    const textSlideAria = useI18n('textSlideAria');

    const wltpItems = wltpData
      ? wltpData?.map((wltpItem, i: number) => (
          // eslint-disable-next-line react/no-array-index-key
          <WltpText key={`con-${i}`} testId={`wltp-con-${testId}`}>
            {wltpItem.formattedConsumption}
            {'; '}
            {wltpItem.formattedEmission}
            {wltpItem.formattedCo2Class && (
              <>
                {'; '}
                {wltpItem.formattedCo2Class}
              </>
            )}
            {wltpItem.formattedDischargedConsumption && (
              <>
                {'; '}
                {wltpItem.formattedDischargedConsumption}
              </>
            )}
            {wltpItem.formattedDischargedCo2Class && (
              <>
                {'; '}
                {wltpItem.formattedDischargedCo2Class}
              </>
            )}
          </WltpText>
        ))
      : [];

    if (content.additionalText) {
      wltpItems.push(
        <Text
          key="alt-phm"
          data-testid={`wltp-alt-${testId}`}
          variant={{ order: process.env.IS_LEGACY ? '2' : '3', style: 'normal' }}
          margin={['4px', 0, 0, 0]}
        >
          {renderTextWithFootnotesReferencesV2(content.additionalText)}
        </Text>,
      );
    }

    const additionalStyles = {
      ...(!active ? { display: 'none' } : null),
    };
    return (
      <StyledTextSlide
        data-testid={testId}
        ref={ref}
        isActive={active}
        aria-hidden={!active}
        tabIndex={active ? 0 : -1}
        style={additionalStyles}
        {...ueProps}
        role="group"
        aria-roledescription={textSlideAria}
      >
        <StyledCopy>
          <Headline
            tag="h3"
            variant={{ type: 'headline', order: '3', weight: 'normal' }}
            data-testid={`headline-${testId}`}
          >
            <StyledHeadline>{renderTextWithFootnotesReferencesV2(content.headline)}</StyledHeadline>
          </Headline>
          {content.subline && (
            <Text variant={{ order: '1', style: 'normal' }} data-testid={`subline-${testId}`}>
              {renderTextWithFootnotesReferencesV2(content.subline)}
            </Text>
          )}
        </StyledCopy>
        <StyledFooter>{wltpItems}</StyledFooter>
      </StyledTextSlide>
    );
  },
);

export default TextSlide;
